/* GluSitePropEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class SelectBoxEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
    }

    _init() {
        const dropDownData = _.get(this._itemData, "siteNodeDropDownData", []);
        this.input.setOptions(dropDownData);
        super._init();
    }

    applyValue(item, state) {
        item[this._fieldName] = state;
        const currentPathObj = item.siteNodeDropDownData.find((i) => i.value === state);
        item["gwPropPath"] = _.get(currentPathObj, "path", []);
        const options = this.input.getOptions();
        const _type = this.findType(options, state);
        item["gwPropType"] = _type;
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        return new SingleComboBoxControl({
            showFilter: true,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false,
        });
    }

    findType(entries, valueToFind) {
        // Iterate through each entry in the input
        for (const entry of entries) {
            // Check if the current entry's value matches the value to find
            if (entry.value === valueToFind) {
                // Return the type if a match is found
                return entry.type;
            }
        }
        // Return null if the value is not found in any entry
        return null;
    }
    hide() {}
    show() {}
}

module.exports = SelectBoxEditor;
